export default {aggregate:"com.armus.product:hybrid-accsts-jsclient:2026.10.02:20261002-2325",
    client: "com.armus:hybrid-jsclient:2026.09.21:20260921-2110",
    requiredApiVersion: "1.86.0",
};



// WEBPACK FOOTER //
// ./app/version.js